module.exports = __webpack_public_path__ + "img/map-pin.52802a79.svg";